
import { defineComponent } from 'vue';
import TheHeader from '@/components/layout/TheHeader.vue';
import { mapState } from 'pinia';
import { useAppStore } from '@/modules/app/store';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default defineComponent({
  name: 'MainWrapper',
  components: { TheHeader, Loading },
  computed: {
    ...mapState(useAppStore, ['isLoading']),
  },
});
